import React from 'react';
import { Bar } from 'react-chartjs-2';

const BarChart = (props) => {
  console.log("Props ",props);
  const data = {
    labels: ["Left", "Right"],
    datasets: [
      {
        label: "Force",
        data: [props.leftForce, props.rightForce],
        backgroundColor: "#6893B4",
        barThickness: 66,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    devicePixelRatio: window.devicePixelRatio || 1,
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          color: "#6893B4",
          size: 14,
          weight: "bold",
          family: "Poppins",
        },
      },
      y: {
        beginAtZero: false,
        min: 90,
        max:130,
        ticks: {
          stepSize: 5,
          color: "#979797",
          size: 14,
          family: "Poppins",
        },
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
      },
      legend: {
        labels: {
          font: {
            size: 14,
          },
        },
      },
      annotation: {
        annotations: {
          targetLine: {
            type: "line",
            yMin: props.targetForce,
            yMax: props.targetForce,
            borderColor: "#54C7BC",
            borderWidth: 21,
            scaleID: "y",
            value:props.targetForce,
            label: {
              display: props.displayTargetForce,
              enabled: props.displayTargetForce,
              content: "Target Force",
              position: "center",
              xAdjust: 0,
              yAdjust: 0,
              backgroundColor: "transparent",
              color: "red",
              font: {
                size: 14,
                family: "Poppins",
                style: "normal",
              },
            },
          },
        },
      },
    },
  };

  return <Bar data={data} options={options} height={400} />;
};

export default BarChart;